import * as React from "react";
import { forwardRef } from "react";
const SvgRelationRight = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 29 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	id: "testIcon",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M7.5 7.00003H0V5.00001H7.5V7.00003Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M23 7.00003H15.5V5.00001H23V7.00003Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M11.5 10.5C13.9852 10.5 16 8.48529 16 6C16 3.51472 13.9852 1.5 11.5 1.5C9.01477 1.5 7 3.51472 7 6C7 8.48529 9.01477 10.5 11.5 10.5ZM11.5 9C13.1569 9 14.5 7.65686 14.5 6C14.5 4.34315 13.1569 3.00001 11.5 3.00001C9.84314 3.00001 8.5 4.34315 8.5 6C8.5 7.65686 9.84314 9 11.5 9Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M24 12L22.5 10.5L26.5 6L22.5 1.5L24 0L29 5.99995L24 12Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13 6C13 6.82843 12.3284 7.5 11.5 7.5C10.6716 7.5 10 6.82843 10 6C10 5.17157 10.6716 4.5 11.5 4.5C12.3284 4.5 13 5.17157 13 6Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgRelationRight);
export default ForwardRef;
